import React from "react";

import TextBodySection from '../components/TextBodySection';

// policiesContent.js (example file)
export const privacyPolicyMarkdown = `

**Última actualización: 21 de febrero de 2025**

### 1. Introducción

La presente Política de Privacidad describe cómo **EquipoMAG** (en adelante, “nosotros” o el “Titular”) recopila, utiliza y protege la información personal de los usuarios (en adelante, “Usuario” o “Usuarios”) que acceden a nuestro sitio web [https://www.equipomag.com](https://www.equipomag.com) (en adelante, el “Sitio Web”), así como la relativa a la prestación de nuestros servicios de asesoría en naturopatía alimentaria, apoyo psicológico, soluciones para empresas y otros servicios relacionados.

---

### 2. Datos que Recopilamos

1. **Información de contacto:** Podemos recopilar tu nombre, correo electrónico y número de teléfono cuando completas formularios de contacto o solicitas información para la contratación de nuestros servicios.

2. **Información de navegación:** Incluye datos sobre tu dispositivo, dirección IP, tipo de navegador, idioma, páginas visitadas y tiempos de permanencia. Recogemos esta información mediante cookies y tecnologías similares.

3. **Datos necesarios para la prestación de los servicios:** Si nos contratas para servicios específicos (por ejemplo, asesoramiento o consultorías), podríamos solicitar información adicional relacionada con tu salud o preferencias alimentarias, siempre de forma voluntaria y con tu consentimiento.

---

### 3. Finalidad del Tratamiento

- **Prestación de servicios:** Gestionar y dar respuesta a tus solicitudes, así como brindarte la información o los servicios que solicites (p. ej., asesoramiento personalizado).
- **Comunicaciones y boletines informativos:** Enviarte información relevante sobre nuestros servicios, noticias o eventos relacionados con EquipoMAG. Puedes darte de baja en cualquier momento.
- **Mejora del Sitio Web y análisis de uso:** Usamos datos de navegación (de forma anónima o agregada) para mejorar la experiencia de usuario y optimizar nuestro contenido.
- **Cumplimiento normativo:** Dar respuesta a obligaciones legales que nos resulten de aplicación, especialmente en materia contable, fiscal y de protección de datos.

---

### 4. Base Jurídica

- **Consentimiento:** Cuando completas nuestros formularios, solicitas información o te suscribes a comunicaciones comerciales.
- **Ejecución de un contrato:** Cuando necesitas contratar nuestros servicios y es imprescindible tratar tus datos para gestionar dicha relación.
- **Interés legítimo:** Para fines de seguridad, prevención del fraude y mejora de la calidad del Sitio Web, siempre que estos intereses no perjudiquen tus derechos.

---

### 5. Uso de Herramientas de Análisis y Terceros

- **Herramientas de análisis (Analytics):** Empleamos servicios de terceros (como Google Analytics u otras plataformas) para entender cómo se utiliza el Sitio Web y mejorar la experiencia del Usuario. Estas herramientas pueden utilizar cookies y recopilar ciertos datos (como IP o actividad de navegación).

- **Servicios externos:** Podemos compartir datos con terceros que nos ayudan a prestar servicios (hosting, pasarelas de pago, marketing, etc.), siempre bajo acuerdos de confidencialidad y cumpliendo con la normativa de protección de datos (GDPR).

---

### 6. Conservación de Datos

Conservaremos tus datos personales durante el tiempo necesario para cumplir con las finalidades descritas en esta Política de Privacidad y mientras exista un interés legítimo o una obligación legal de mantenerlos.

---

### 7. Derechos del Usuario

Tienes derecho a:

- **Acceder** a los datos personales que tenemos sobre ti.  
- **Rectificarlos** si son inexactos o incompletos.  
- **Solicitar su supresión** cuando ya no sean necesarios para los fines para los que fueron recopilados o cuando revoques tu consentimiento.  
- **Oponerte** al tratamiento de tus datos en determinadas circunstancias, especialmente si se basa en un interés legítimo.  
- **Limitar** el tratamiento, solicitando la conservación de los datos pero no su uso activo.  
- **Portar** los datos a otro responsable cuando sea técnicamente posible.

Para ejercer tus derechos, puedes contactar con nosotros mediante correo electrónico a **info@equipomag.com** indicando en el asunto “Protección de Datos” y adjuntando una copia de un documento acreditativo de tu identidad.

---

### 8. Medidas de Seguridad

EquipoMAG aplica medidas técnicas y organizativas apropiadas para proteger tus datos contra pérdida, uso indebido, acceso no autorizado, alteración o destrucción, de conformidad con la normativa europea de protección de datos (GDPR).

---

### 9. Uso de Cookies

En el Sitio Web utilizamos cookies y otras tecnologías de seguimiento para proporcionar funcionalidad y analizar la navegación. Para más detalles, consulta nuestra sección o política específica de Cookies (incluida en el propio Sitio Web).

---

### 10. Modificaciones

Podemos actualizar la presente Política de Privacidad en cualquier momento. Cualquier cambio se publicará en el Sitio Web, indicando la fecha de la última revisión al inicio de este documento. El uso continuado de nuestros servicios tras la publicación de esos cambios implicará la aceptación de los mismos.

---

### 11. Contacto

Para cualquier consulta o duda sobre esta Política de Privacidad, puedes escribirnos a:  
**info@equipomag.com**

CLÁUSULA INFORMATIVA - UNIVERSO AOKI, S.L.U, C/ DELFIN, 41, ALCALA DEL RIO, SEVILLA. Nombre/Apellidos y DNI del padre o tutor: ______________________________________.
(c) Edutedis Consultoria, S.L.U. - C./Baza Parc.11, Loc.16-17 - Albolote (Granada).
CLÁUSULAS – PROTECCIÓN DE DATOS
He sido informado que mis datos personales serán incorporados a ficheros para el tratamiento denominado CLIENTES cuyo responsable es UNIVERSO AOKI, S.L.U. Que la finalidad del tratamiento es la gestión de la relación comercial, económica y
administrativa con los clientes, cuya base legal es el tratamiento es necesario para la ejecución de un contrato en el que el interesado es parte o para la aplicación, a petición de éste, de medidas precontractuales. Que para el cumplimiento de la finalidad,
o por exigencias legales, sus datos personales podrán ser cedidos o comunicados a Organismos e instituciones públicas, Empresas o profesionales directamente relacionados con el responsable. Que el plazo para la supresión de mis datos personales será
el previsto por la legislación fiscal respecto a la prescripción de responsabilidades. También he sido informado del derecho a solicitar al responsable del tratamiento el acceso a mis datos personales, y su rectificación o supresión, o la limitación de su
tratamiento, o a oponerme al tratamiento, y a presentar una reclamación ante una autoridad de control. Otorgo mi consentimiento para el tratamiento de mis datos personales para la finalidad anteriormente descrita.
Se informa que sus datos personales facilitados por Ud. serán incorporados a ficheros para el tratamiento denominado PACIENTES cuyo responsable es UNIVERSO AOKI, S.L.U.. La finalidad del tratamiento es la gestión de las actuaciones de salud y
administrativas de los pacientes, cuya base legal es el tratamiento es necesario para la ejecución de un contrato en el que el interesado es parte o para la aplicación, a petición de éste, de medidas precontractuales. Los datos que se le soliciten son los
necesarios para la realización del servicio contratado, y entre ellos se le solicitarán datos relativos a Salud física o mental.. Ud. No está obligado a facilitar estos datos, pero la negativa a facilitarlos o a proporcionarlos erróneos puede limitar la realización
del servicio. Que para el cumplimiento de la finalidad, o por exigencias legales, sus datos personales podrán ser cedidos o comunicados a Profesionales de la salud. El plazo para la supresión de los datos personales será el previsto por la legislación sanitaria
para la prescripción de responsabilidades. También se le informa del derecho a solicitar al responsable del tratamiento el acceso a los datos personales relativos a Ud. y su rectificación o supresión, o la limitación de su tratamiento, o a oponerse al
tratamiento, y a presentar una reclamación ante una autoridad de control. Otorgo el consentimiento para el tratamiento de mis datos personales para la finalidad y en los términos manifestados anteriormente. Se informa que los datos personales
facilitados por Ud. y los del menor de 14 años bajo su tutela en su caso serán incorporados a ficheros para el tratamiento denominado PACIENTES cuyo responsable es UNIVERSO AOKI, S.L.U.
Política de devoluciones: La devolución será abonada proporcionalmente al servicio disfrutado. Es importante resaltar que un BONO está sujeto a un descuento, y así se disfrutará, de ser finalizado. La interrupción es motivo del cobro normal de las consultas,
siendo esta cantidad restada al total del importe del bono. Las situaciones en las que se hará efectiva la devolución son: Enfermedad física o mental diagnosticada que impida el acudir a consulta y la imposibilidad de desplazamiento por cambio de domicilio.
Deberá aportarse documentación.
`;

const PrivacyPage = () => {
  return (
    <>
      <TextBodySection
        policyMarkdown={privacyPolicyMarkdown}
      />
    </>
  );
};

export default PrivacyPage;
